export const MORNING_HOURS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(String);
export const AFTERNOON_HOURS = [12, 13, 14, 15, 16, 17].map(String);
export const EVENING_HOURS = [18, 19, 20, 21, 22, 23].map(String);

export const MORNING_KEY = 'morning';
export const AFTERNOON_KEY = 'afternoon';
export const EVENING_KEY = 'evening';
